import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";
import { getUserOrder } from "../../api/app";
import Footer from "../../components/layout/Footer";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";

const Order = () => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    getUserOrder().then((response) => {
      if (!response.error) {
        setOrders(response.orders);
        setLoading(false);
      }
    });
  }, []);

  return (
    <div>
      {loading ? (
        <div className="h-screen flex item-center justify-center">
          <div className="loader">
            <BeatLoader color="#003074" size={20} />
          </div>
        </div>
      ) : (
        <div>
          <div className="container">
            <div className="max-w-3xl mx-auto">
              <div className="rounded-md shadow-md">
                <h3 className="border-b font-semibold px-5 py-4 text-base text-gray-500">
                  {orders.length !== 0 ? orders.length : "No"} Order
                </h3>
                {orders.length !== 0
                  ? orders.map((item) => {
                      const handleDownloadReceipt = async (id) => {
                        const receiptElement = document.getElementById(
                          `receipt-${id}`
                        );
                        if (!receiptElement) return;
                        const canvas = await html2canvas(receiptElement, {
                          scale: 2,
                        });
                        const imgData = canvas.toDataURL("image/png");
                        // Convert canvas dimensions from px to pt used for pdf (1px = 0.75pt)
                        const pdfWidth = canvas.width * 0.75;
                        const pdfHeight = canvas.height * 0.75;
                        const orientation =
                          pdfWidth > pdfHeight ? "landscape" : "portrait";
                        const pdf = new jsPDF({
                          orientation,
                          unit: "pt",
                          format: [pdfWidth, pdfHeight],
                        });
                        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                        pdf.save(`receipt-${id}.pdf`);
                      };

                      return (
                        <React.Fragment key={item.id_number}>
                          <div
                            className="flex justify-center py-10"
                            key={item.id_number}
                          >
                            <div
                              id={`receipt-${item.id_number}`}
                              className="bg-white shadow-lg rounded-md p-8 w-96"
                              style={{ fontFamily: "monospace" }}
                            >
                              <div className="flex flex-col items-center mb-4">
                                <img
                                  src="/assets/images/logo.png"
                                  alt="Logo"
                                  className="h-12 w-auto mb-2"
                                />
                              </div>
                              <div className="text-sm text-gray-700 mb-2">
                                <div>
                                  Date:{" "}
                                  {moment(item.date.str).format("DD/MM/YY")}
                                </div>
                                <div>Order Id: {item.id_number}</div>
                                <div>
                                  Delivery Address: {item.delivery_address}
                                </div>
                              </div>
                              <div className="font-bold text-lg mb-2 text-center">
                                SALE Receipt
                              </div>
                              {/* Table Header */}
                              <div className="mb-2">
                                <div className="flex justify-between font-bold border-b-2 border-dashed border-red-200 pb-1">
                                  <span className="w-2/6">Product</span>
                                  <span className="w-1/12 text-center">
                                    Qty
                                  </span>
                                  <span className="w-1/6 text-right">
                                    Price
                                  </span>
                                  <span className="w-1/6 text-right">VAT</span>
                                  <span className="w-1/6 text-right">
                                    Total
                                  </span>
                                </div>
                              </div>
                              {/* Table Body */}
                              <div className="mb-2">
                                {item.items.map((order, idx) => {
                                  const vat = +(order.ori_price * 0.16).toFixed(
                                    2
                                  );
                                  const total = +(
                                    (order.ori_price + vat) *
                                    order.quantity
                                  ).toFixed(2);
                                  const price = +order.ori_price.toFixed(2);
                                  return (
                                    <div
                                      key={order._id || idx}
                                      className="flex justify-between items-center"
                                    >
                                      <span className="w-2/6">
                                        {order.doc.name}
                                      </span>
                                      <span className="w-1/12 text-center">
                                        {order.quantity}
                                      </span>
                                      <span className="w-1/6 text-right">
                                        {price.toFixed(2)}
                                      </span>
                                      <span className="w-1/6 text-right">
                                        {vat.toFixed(2)}
                                      </span>
                                      <span className="w-1/6 text-right">
                                        {total.toFixed(2)}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                              <hr className="border-dashed border-t-2 border-red-200 my-2" />
                              <div className="flex justify-between font-bold mb-1">
                                <span>Subtotal</span>
                                <span className="w-1/6 text-right">VAT</span>
                                <span className="w-1/6 text-right">
                                  {item.items
                                    .reduce(
                                      (sum, order) =>
                                        sum +
                                        order.ori_price * 0.16 * order.quantity,
                                      0
                                    )
                                    .toFixed(2)}
                                </span>
                              </div>
                              {/* Total */}
                              <div className="flex justify-between font-bold">
                                <span>Total</span>
                                <span className="w-1/6 text-right">
                                  {item.items
                                    .reduce(
                                      (sum, order) =>
                                        sum +
                                        (order.ori_price +
                                          order.ori_price * 0.16) *
                                          order.quantity,
                                      0
                                    )
                                    .toFixed(2)}
                                </span>
                              </div>
                              <hr className="border-dashed border-t-2 border-red-200 my-2" />
                              <div className="text-center mt-4 font-semibold text-gray-500">
                                Thank you for shopping!
                              </div>
                              <div
                                className="text-center mt-4 font-semibold text-gray-500 underline cursor-pointer"
                                onClick={() =>
                                  handleDownloadReceipt(item.id_number)
                                }
                              >
                                Download receipt
                              </div>
                            </div>
                          </div>
                          <div className="w-full flex justify-center mb-10">
                            <hr className="border-t-4  rounded w-2/3" />
                          </div>
                        </React.Fragment>
                      );
                    })
                  : null}
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Order;
